export const getInfo = rules => {
  if (!rules) return "";
  let textArr = [];
  let text = "";
  const { capitals, nonAlphanumeric, digits, length } = rules;
  if (capitals && capitals > 0) {
    if (capitals > 1) {
      textArr = [...textArr, `minst ${capitals} stora bokstäver (A-Z)`];
    } else {
      textArr = [...textArr, `minst ${capitals} stor bokstav (A-Z)`];
    }
  }
  if (nonAlphanumeric && nonAlphanumeric > 0) {
    textArr = [...textArr, `minst ${nonAlphanumeric} specialtecken (!?#%*)`];
  }
  if (digits && digits > 0) {
    if (digits > 1) {
      textArr = [...textArr, `minst ${digits} siffror (0-9)`];
    } else {
      textArr = [...textArr, `minst ${digits} siffra (0-9)`];
    }
  }
  if (length) {
    textArr = [...textArr, `minst ${length} tecken totalt`];
  }
  for (let i = 0; i < textArr.length; i++) {
    if (i < textArr.length - 1) {
      text = text + textArr[i] + ", ";
    } else {
      text = text + textArr[i];
    }
  }
  return text;
};
